import React from 'react';

import { Row, Col } from '../../components/Grid';
import { SectionLayout } from '../../components/Layouts';

import GraphicBurst from '../../components/GraphicBurst';
import { HeadlineTitle } from '../../components/Title';

import data from './data';

const WhyJoin = () => {
  return (
    <SectionLayout>
      <HeadlineTitle color="midnight">Why join Tempo Time Credits?</HeadlineTitle>
      <Row mt={2} mtT={0}>
        <Col w={[4, 3, 4]} mt={4} mtT={5}>
          <GraphicBurst
            image={data[0].image}
            leftAligned={data[0].leftAligned}
            title={data[0].title}
            location={data[0].location}
          />
        </Col>
        <Col w={[4, 3, 4]} mt={4} mtT={5}>
          <GraphicBurst
            image={data[1].image}
            leftAligned={data[1].leftAligned}
            title={data[1].title}
            location={data[1].location}
          />
        </Col>
        <Col w={[4, 3, 4]} mt={4} mtT={5}>
          <GraphicBurst
            image={data[2].image}
            leftAligned={data[2].leftAligned}
            title={data[2].title}
            location={data[2].location}
          />
        </Col>
        <Col w={[4, 3, 4]} mt={4} mtT={5}>
          <GraphicBurst
            image={data[3].image}
            leftAligned={data[3].leftAligned}
            title={data[3].title}
            location={data[3].location}
          />
        </Col>
        <Col w={[4, 3, 4]} mt={4} mtT={5}>
          <GraphicBurst
            image={data[4].image}
            leftAligned={data[4].leftAligned}
            title={data[4].title}
            location={data[4].location}
          />
        </Col>
        <Col w={[4, 3, 4]} mt={4} mtT={5}>
          <GraphicBurst
            image={data[5].image}
            leftAligned={data[5].leftAligned}
            title={data[5].title}
            location={data[5].location}
          />
        </Col>
      </Row>
    </SectionLayout>
  );
};

export default WhyJoin;
